import { Autocomplete, Box, FormControl, TextField } from '@mui/material';
import React from 'react';
import timezones from '../../data/timezones';

export default function SelectTimeZone({ selectedTimezone, setSelectedTimezone }) {
  return (
    <Box sx={{ marginTop: '20px', marginBottom: '30px' }}>
      <FormControl fullWidth>
        <Autocomplete
          fullWidth
          options={timezones.map((tz) => tz.text)}
          value={selectedTimezone || ''}
          onChange={(event, newValue) => setSelectedTimezone(newValue)}
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
            //   label="Select Timezone"
              placeholder="Search..."
            />
          )}
        />
      </FormControl>
    </Box>
  );
}
